export const PATH_BASE = '/panel';
export const PATH_FEATURES = '/app/:appId/features';
export const PATH_FEATURES_LIST = '/app/:appId/features/:env';
export const PATH_APPLICATIONS = '/applications';
export const PATH_AUDIT_LOGS = '/auditlogs';

// utils
export const PATH_SEARCH_APPID = '/app/:appId';
export const PATH_WITH_ENV = [PATH_FEATURES_LIST];
